<template>
  <page-header :breadcrumRoutes="routes" title="Baja individual">
    <template #tags>
      <tags
        :stateId="ticketStateId"
        :loading="true"
        v-if="ticketStateId !== ''"
      />
      <tags :stateId="1" :loading="true" v-else />
      <tags color="processing">ID: {{ exclusionId }}</tags>
    </template>

    <template #buttons v-if="userRole != 'rrhh'">
      <a-space wrap :size="8">
        <a-button
          v-if="ticketStateId == 1 || ticketStateId == 7 || ticketStateId == 8"
          @click="openCancelModal"
          :disabled="loading"
          :loading="loading"
        >
          Cancelar
        </a-button>
        <a-button
          v-if="ticketStateId == 1"
          type="primary"
          :loading="loading"
          :disabled="loading"
          @click="sendToBewell"
        >
          Enviar a revisión
        </a-button>
        <a-button
          v-if="ticketStateId == 7"
          type="primary"
          :loading="loading"
          :disabled="loading"
          @click="sendToInsurance"
        >
          Enviar a aseguradora
        </a-button>
        <a-button
          v-if="ticketStateId == 8"
          @click="() => (updateEndDateVisible = true)"
          :disabled="loading"
          :loading="loading"
        >
          Editar fecha de término
        </a-button>
        <a-button
          v-if="ticketStateId == 8"
          type="primary"
          :loading="loading"
          :disabled="loading"
          @click="openExecuteModal"
        >
          Ejecutar
        </a-button>
      </a-space>
    </template>

    <template #content-below-title>
      <div
        v-if="ticket.ticketGroupId"
        style="margin-top: 0px; font-size: 14px"
        class="ant-page-header-content"
      >
        <a-button
          type="primary"
          class="mb-0"
          @click="goToTicketGroup(ticket.ticketGroupId)"
        >
          Ticket masivo: #{{ ticket.ticketGroupId }}
        </a-button>
      </div>
    </template>
  </page-header>

  <a-modal
    :wrapClassName="'modal-xs'"
    v-model:visible="updateEndDateVisible"
    title="Editar fecha de término"
    @ok="updateEndDate"
  >
    <a-date-picker
      format="DD-MM-YYYY"
      style="width: 100%"
      v-model:value="newEndDate"
    />
  </a-modal>

  <stepper
    ticketType="baja"
    :state="stepperProps.state"
    :stateDates="stepperProps.dates"
    ref="stepperRef"
  />

  <a-card>
    <a-row :gutter="[16, 16]">
      <a-col :xs="24" :md="12">
        <datos-ticket
          :data="dataToTable"
          title="Datos corporativos"
          :loadTicket="loadTicket"
        />

        <a-table
          class="mt-3"
          :data-source="policyHolderExclusionRows"
          :pagination="false"
          :loading="loadTicket"
          :columns="coverageExclusionColumns"
          row-key="id"
        >
          <template #title>Coberturas a dar de baja</template>
        </a-table>

        <a-alert
          class="mt-3"
          type="info"
          show-icon
          message="Información"
          description="Se darán de baja las coberturas seleccionadas y las cargas asociadas a ellas."
        />

        <a-alert
          v-if="dependentPreviewError"
          type="error"
          show-icon
          message="No se pudo validar la vista previa de cargas"
          :description="dependentPreviewError"
          class="mt-3"
        />
        <a-alert
          v-if="
            !dependentPreviewError &&
            !loadingDependentPreview &&
            dependentPreviewRows.length === 0
          "
          type="info"
          show-icon
          message="No hay cargas asociadas"
          :description="
            dependentPreviewEmptyMessage ||
            'No se encontraron cargas activas para las coberturas staged.'
          "
          class="mt-3"
        />

        <a-table
          class="mt-3"
          :data-source="dependentPreviewRows"
          :pagination="false"
          :loading="loadingDependentPreview"
          :columns="dependentPreviewColumns"
          row-key="id"
        >
          <template #title>Cargas que se darán de baja</template>
        </a-table>

        <a-card
          class="mt-3"
          v-if="userRole != 'rrhh'"
          title="Casos asociados"
          bodyStyle="padding: 24px 24px 24px 24px; border: 1px solid #f0f0f0; border-top-width: 0px;"
          :bordered="false"
        >
          <div v-if="cases.length == 0">
            <a-typography-text>No existen casos</a-typography-text>
          </div>

          <a-row
            type="flex"
            justify="space-between"
            v-for="c in cases"
            :key="c.id"
          >
            <a-col :span="6">
              <a-typography-text>{{ c.state }}</a-typography-text>
            </a-col>
            <a-col>
              <tags :stateId="c.tag" />
            </a-col>
            <a-col>
              <a-button type="link" @click="redirectCase(c)">
                Ir a caso
              </a-button>
            </a-col>
            <a-divider class="my-2" v-if="cases.length > 1" />
          </a-row>
        </a-card>
      </a-col>
      <a-col :xs="24" :md="12">
        <records
          title="Historial"
          :loadingHistory="loadingHistory"
          :data="orderedRecords"
          v-if="userRole != 'rrhh'"
        />

        <attached-documents
          v-if="userRole != 'rrhh' && ticketOptionalFiles.length > 0"
          class="mt-3"
          title="Archivos opcionales"
          :data="ticketOptionalFiles"
          :loading="loadingOptionalFiles"
        />

        <message-to-insurance
          v-if="insuranceMessage != null && userRole !== 'rrhh'"
          class="mt-3"
          :message="insuranceMessage"
        />

        <comments
          v-if="userRole != 'rrhh'"
          class="mt-3"
          :comments="commentsOrdered"
          :idToTicket="exclusionId"
          @new_comment="getNewCommment"
        />
      </a-col>
    </a-row>
  </a-card>
</template>

<script>
import { reactive, ref, computed, createVNode, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { ExclamationCircleOutlined } from '@ant-design/icons-vue';
import openNotificationWithIcon from '@/utils/notifications';
import { Modal } from 'ant-design-vue';
import { useStore } from 'vuex';
import Stepper from '@/components/tickets/stepper.vue';
import DatosTicket from '@/components/tickets/ticket-data.vue';
import Records from '@/components/tickets/records.vue';
import AttachedDocuments from '@/components/tickets/attached-documents.vue';
import MensajeAseguradora from '@/components/tickets/insurer-message.vue';
import Comments from '@/components/tickets/comments.vue';
import notification from '@/utils/notifications';
import parseDate from '@/utils/dateFormatter';
import { normalizePicker } from '@/utils/calendarDay';
import { useTicketStepper } from '@/composables/use-ticket-stepper';
import {
  GET_LOGGED_USER,
  FETCH_V2_POLICY_HOLDER_TICKET,
  FETCH_V2_POLICY_HOLDER_EXCLUSIONS,
  FETCH_V2_EMPLOYEE_COVERAGES_WITH_DEPENDENTS,
  PATCH_V2_POLICY_HOLDER_EXCLUSIONS,
  PATCH_V2_POLICY_HOLDER_STATUS,
  FETCH_TICKET_COMMENTS_ID,
  FETCH_CASES,
  FETCH_USER_BY_ID,
  FETCH_RECORD_FILE_TICKET,
  FETCH_TICKET_OPTIONAL_FILES,
  GET_TICKET_OPTIONAL_FILES
} from '@/store/types';
import PageHeader from '@/components/page-header.vue';
import Tags from '@/components/tags.vue';
import rutHelper from '@/utils/Ruts';
import {
  buildCurrentDependentPreview,
  isNoActiveCoveragesError,
  mapCoverageExclusionsToDisplay,
  mapCurrentDependentPreviewToDisplay
} from './individual-exclusion-detail-helpers';
import { flattenActiveCoverageTree } from './individual-exclusion-helpers';

export default {
  name: 'BajaDetail',
  components: {
    stepper: Stepper,
    'datos-ticket': DatosTicket,
    records: Records,
    'attached-documents': AttachedDocuments,
    'message-to-insurance': MensajeAseguradora,
    comments: Comments,
    'page-header': PageHeader,
    tags: Tags
  },
  setup() {
    // * VUEX
    const store = useStore();
    const userRole = store.getters[GET_LOGGED_USER].roleName;
    const showOnlyCancel = ref(false);
    const loadTicket = ref(false);
    const loadingHistory = ref(false);

    const goToTicketGroup = (id) => {
      router.push({
        name: 'BajaMasivaDetail',
        params: { id }
      });
    };
    const updateEndDateVisible = ref(false);
    const newEndDate = ref();
    const policyHolderExclusions = ref([]);
    const loadingDependentPreview = ref(false);
    const activeDependentPreview = ref([]);
    const dependentPreviewError = ref('');
    const dependentPreviewEmptyMessage = ref('');
    const coverageExclusionColumns = [
      { title: 'Cobertura', dataIndex: 'coverageName', key: 'coverageName' },
      { title: 'Póliza', dataIndex: 'policyNumber', key: 'policyNumber' },
      { title: 'Grupo', dataIndex: 'groupName', key: 'groupName' },
      { title: 'Fecha de término', dataIndex: 'endDate', key: 'endDate' }
    ];
    const dependentPreviewColumns = [
      { title: 'Carga', dataIndex: 'dependentName', key: 'dependentName' },
      { title: 'Cobertura', dataIndex: 'coverageName', key: 'coverageName' },
      { title: 'Póliza', dataIndex: 'policyNumber', key: 'policyNumber' },
      { title: 'Grupo', dataIndex: 'groupName', key: 'groupName' }
    ];
    const policyHolderExclusionRows = computed(() =>
      mapCoverageExclusionsToDisplay(policyHolderExclusions.value)
    );
    const dependentPreviewRows = computed(() =>
      mapCurrentDependentPreviewToDisplay(activeDependentPreview.value)
    );

    const updateEndDate = async () => {
      try {
        if (!newEndDate.value) {
          notification('error', 'Error', 'Debe seleccionar una fecha.');
          return;
        }
        const endDate = normalizePicker(newEndDate.value);
        await store.dispatch(PATCH_V2_POLICY_HOLDER_EXCLUSIONS, {
          ticketId: exclusionId,
          endDate
        });
        await getTicketData(exclusionId);

        // The PATCH response does not include the nested coverage, policy and
        // group relations used by both detail tables. Reload the hydrated
        // exclusions, just like a full page reload does.
        policyHolderExclusions.value =
          (await store.dispatch(
            FETCH_V2_POLICY_HOLDER_EXCLUSIONS,
            exclusionId
          )) || [];
        await loadDependentPreview(ticket.employee?.id);
        updateEndDateVisible.value = false;
        newEndDate.value = undefined;
      } catch (error) {
        console.error(error);
        let errMsg = error?.response?.data?.message;
        if (!errMsg) {
          errMsg =
            'Ha ocurrido un error al cambiar la fecha de término. Favor intentar más tarde.';
        }
        notification('error', 'Error', errMsg);
      }
    };

    // * Obtener la id desde la ruta url en la que estoy
    const route = useRoute();
    const exclusionId = route.params.id; // id de la baja que estoy viendo

    // * Rutas
    const routes = [
      {
        path: '/bajas',
        breadcrumbName: 'Bajas'
      },
      {
        path: '#',
        breadcrumbName: 'Individual'
      },
      {
        breadcrumbName: `#${exclusionId}`
      }
    ];

    const getBroker = async (id) => {
      const response = await store.dispatch(FETCH_USER_BY_ID, id);
      return response.data.body.name;
    };

    // * Stepper
    const stepperRef = ref('null');

    const router = useRouter();
    const recordsComments = reactive([]);
    const recordsFiles = reactive([]);
    const ticketOptionalFiles = ref([]);
    const loadingOptionalFiles = ref(false);

    const {
      recordsSteps,
      stepperProps,
      headerStateData,
      ticketStateId,
      rebuild: rebuildStepper
    } = useTicketStepper(null, {
      onCancel: () => stepperRef.value?.cancelStep?.(),
      onFinish: () => stepperRef.value?.finishStep?.()
    });

    const getTicketOptionalFiles = async () => {
      loadingOptionalFiles.value = true;
      try {
        if (userRole != 'rrhh') {
          await store.dispatch(FETCH_TICKET_OPTIONAL_FILES, exclusionId);
        }
        ticketOptionalFiles.value =
          await store.getters[GET_TICKET_OPTIONAL_FILES];
        loadingOptionalFiles.value = false;
      } catch (error) {
        openNotificationWithIcon(
          'error',
          'Error',
          `Error al cargar archivos opcionales del Ticket ${exclusionId}. ${error}`
        );
        loadingOptionalFiles.value = false;
      }
    };

    const stepperData = async (id, ticketDataParam) => {
      // Thin wrapper: fetch the ticket (or reuse a pre-fetched payload)
      // and delegate stepper-state construction to useTicketStepper.
      // The 5x-duplicated stepper-building algorithm + getStateType
      // switch-case now lives in src/composables/use-ticket-stepper.js.
      loadingHistory.value = true;
      try {
        let ticketData;
        if (ticketDataParam) {
          ticketData = ticketDataParam;
        } else {
          ticketData = await store.dispatch(FETCH_V2_POLICY_HOLDER_TICKET, id);
        }
        if (ticketData.type.id != 2) {
          return router.push({ name: 'Missing' });
        }
        showOnlyCancel.value = false;
        rebuildStepper(ticketData);
        loadingHistory.value = false;
      } catch (error) {
        loadingHistory.value = false;
        console.log('error', error);
      }
    };

    // * Ticket
    // * Compania a seguradora y polizas
    const policies = ref([]);
    const ticket = reactive({
      employee: '',
      company: '',
      insurance: '',
      policies: '',
      endDate: '',
      messageInsurance: '',
      brokerId: null,
      ticketGroupId: null
    });
    const getTicketData = async (id) => {
      loadTicket.value = true;
      try {
        // Metodo para obtener data y llenar el ticket
        const ticketData = await store
          .dispatch(FETCH_V2_POLICY_HOLDER_TICKET, id)
          .catch(() => router.push({ name: 'Missing' }));
        if (!ticketData) {
          loadTicket.value = false;
          return null;
        }
        const data = ticketData.policies;
        policies.value = [];
        for (let i = 0; i < data.length; i++) {
          const element = data[i];
          policies.value.push(element.numberPolicy);
        }
        ticket.brokerId = ticketData.brokerId;
        ticket.employee = ticketData.employee;
        ticket.company = ticketData.company;
        ticket.insurance = ticketData.insuranceCompany.businessName;
        ticket.messageInsurance = ticketData.message;
        insuranceMessage.value = ticketData.message;
        ticket.ticketGroupId = ticketData.ticketGroupId;

        ticket.policies = policies.value
          .reduce((acc, item) => {
            return [...acc, item];
          }, '')
          .toString();
        ticket.endDate = parseDate(ticketData.endDate).substring(0, 10);

        const valueToRecords = ticketData.states;
        fillRecordsWithStates(valueToRecords);
        loadTicket.value = false;
        return ticketData;

        // loadTicket.value=false;
      } catch (error) {
        loadTicket.value = false;
        console.log('error', error);
        return null;
      }
    };

    const loadDependentPreview = async (employeeId) => {
      loadingDependentPreview.value = true;
      dependentPreviewError.value = '';
      dependentPreviewEmptyMessage.value = '';
      try {
        if (!employeeId) {
          activeDependentPreview.value = buildCurrentDependentPreview(
            policyHolderExclusions.value,
            []
          );
          return;
        }
        const tree = await store.dispatch(
          FETCH_V2_EMPLOYEE_COVERAGES_WITH_DEPENDENTS,
          { employeeId }
        );
        const activeCoverages = flattenActiveCoverageTree(tree);
        activeDependentPreview.value = buildCurrentDependentPreview(
          policyHolderExclusions.value,
          activeCoverages
        );
      } catch (error) {
        if (error instanceof TypeError) {
          dependentPreviewError.value = error.message;
          throw error;
        }
        if (isNoActiveCoveragesError(error)) {
          // Not a failure: show the empty-preview notice with the reason.
          dependentPreviewEmptyMessage.value = error.response.data.message;
          activeDependentPreview.value = buildCurrentDependentPreview(
            policyHolderExclusions.value,
            []
          );
          return;
        }
        // Staging/detail remains usable when the supplemental preview request
        // is unavailable; it is current context, not ticket data.
        dependentPreviewError.value =
          'No se pudo obtener la información actual de cargas.';
        activeDependentPreview.value = buildCurrentDependentPreview(
          policyHolderExclusions.value,
          []
        );
      } finally {
        loadingDependentPreview.value = false;
      }
    };

    // Casos
    const cases = ref([]);

    const getAllCasesByTicketId = async (id) => {
      cases.value = [];

      const responseCases = await store
        .dispatch(FETCH_CASES, id)
        .catch((e) => e.response);

      for (let i = 0; i < responseCases.data.length; i++) {
        const obj = {
          id: '',
          tag: '',
          state: '',
          typeCaseId: 0
        };

        const caso = responseCases.data[i];

        obj.id = caso.id;
        obj.tag = caso.states
          .sort((a, b) => {
            return b.id - a.id;
          })[0]
          .state.id.toString();
        obj.state = caso.typeCase.tag;
        obj.typeCaseId = caso.typeCaseId;

        cases.value.push(obj);
      }
    };

    const redirectCase = (value) => {
      const ticketId = value.id;

      const ticketType =
        value.state === 'Out of Time'
          ? 'fuera_de_tiempo'
          : value.state.toLowerCase();

      switch (ticketType) {
        case 'fuera de tiempo: baja individual':
          router.push({ name: 'DetalleFueraTiempo', params: { id: ticketId } });
          break;
      }
    };

    // * Comentarios
    const comments = ref([]);

    // Obtener comentarios desde backend
    const getCommentsFromTicket = async (id) => {
      comments.value.length = 0;

      const response = await store
        .dispatch(FETCH_TICKET_COMMENTS_ID, id)
        .catch((e) => e.response);

      const list = response.data ?? response; // por si acaso

      for (let i = 0; i < list.length; i++) {
        const element = list[i];
        const brokerName = await getBroker(element.brokerId);

        comments.value.push({
          message: element.message,
          createdAt: element.createdAt,
          brokerName
        });
      }

      fillRecordsWithComents(comments.value);
    };

    const getNewCommment = async (value) => {
      const { brokerId } = value;
      const brokerName = await getBroker(brokerId);

      comments.value.push({
        message: value.title,
        createdAt: value.description,
        brokerName
      });

      records.push({
        title: 'Nuevo comentario',
        description: value.description
      });
    };

    const commentsOrdered = computed(() => {
      const rows = [];

      for (let i = 0; i < comments.value.length; i++) {
        const element = comments.value[i];
        const finishDate = new Date(element.createdAt);

        rows.push({
          description: parseDate(finishDate),
          title: element.message,
          author: element.brokerName
        });
      }

      rows.sort((a, b) => new Date(a.description) - new Date(b.description));

      return rows;
    });

    // * Archivos
    const file_records = ref([]);
    const getFilesRecordsFromTicket = async (id) => {
      // Metodo para obtener data del registro de los archivos enviados por ticket

      file_records.value.length = 0;
      const file_records_response = await store.dispatch(
        FETCH_RECORD_FILE_TICKET,
        id
      );
      for (let i = 0; i < file_records_response.length; i++) {
        const element = file_records_response[i];
        file_records.value.push(element);
      }

      fillRecordsWithFilesHistory(file_records.value);
    };

    // const ticketData = ref([]);
    // const crearDataToTable = async (data) =>{
    //   ticketData.value=data;
    // };

    // * Mensaje aseguradora
    const insuranceMessage = ref('');

    // * Historial
    const records = reactive([]);

    // Llenar el historial con estados del ticket
    const fillRecordsWithStates = (data) => {
      for (let i = 0; i < data.length; i++) {
        const element = data[i];
        records.push({
          title: element.state.tag,
          description: element.createdAt
        });
      }
    };

    // Llenar el historial con Comentarios
    const fillRecordsWithComents = (data) => {
      recordsComments.length = 0; // limpiar por si acaso

      for (let i = 0; i < data.length; i++) {
        const element = data[i];
        recordsComments.push({
          title: 'Nuevo comentario',
          description: element.createdAt
        });
      }
    };

    // Llenar el historial con el historial de archivos enviados
    const fillRecordsWithFilesHistory = (data) => {
      for (let i = 0; i < data.length; i++) {
        const element = data[i];
        records.push({
          title: 'Documento enviado',
          description: element.createdAt
        });
      }
    };

    const orderedRecords = computed(() => {
      loadingHistory.value = true;
      const rows = [];
      const records = [recordsSteps, recordsComments, recordsFiles];

      records.forEach((element) => {
        for (let i = 0; i < element.length; i++) {
          const el = element[i];
          if (el.title == 'Ejecutado') {
            rows.push({
              description: new Date(el.description),
              title: el.title,
              status: 'finish'
            });
          } else if (el.title == 'Cancelado') {
            rows.push({
              description: new Date(el.description),
              title: el.title,
              status: 'error'
            });
          } else {
            rows.push({
              description: new Date(el.description),
              title: el.title
            });
          }
        }
        // loadingHistory.value=false;
      });

      rows.sort(function (a, b) {
        return a.description - b.description;
      });

      for (let i = 0; i < rows.length; i++) {
        const element = rows[i];
        const fecha = parseDate(element.description); // formatDate(element.description);
        rows[i].description = fecha;
      }
      return rows;
    });

    // * Formatear fecha

    // const padTo2Digits = (num) => {
    //   return num.toString().padStart(2, '0');
    // };

    // const formatDate = (date) => {
    //   const year    = date.getFullYear();
    //   let month   = date.getMonth()+1;
    //   let day     = date.getDate();
    //   let hour    = date.getHours();
    //   let minute  = date.getMinutes();
    //   let second  = date.getSeconds();
    //   if(month.toString().length == 1) {
    //     month = `0${month}`;
    //   }
    //   if(day.toString().length == 1) {
    //     day = `0${day}`;
    //   }
    //   if(hour.toString().length == 1) {
    //     hour = `0${hour}`;
    //   }
    //   if(minute.toString().length == 1) {
    //     minute = `0${minute}`;
    //   }
    //   if(second.toString().length == 1) {
    //     second = `0${second}`;
    //   }
    //   const dateTime = `${year}/${month}/${day} ${hour}:${minute}:${second}`;
    //   return dateTime;
    // };

    // * Cancelar ticket
    const cancelTickets = async () => {
      loading.value = true;
      try {
        // Hago la request hacia la base de datos
        await store.dispatch(PATCH_V2_POLICY_HOLDER_STATUS, {
          ticketId: exclusionId,
          status: 4
        });
        await getData(exclusionId);
      } catch (error) {
        console.log(error);
      } finally {
        loading.value = false;
      }
    };

    const openCancelModal = () => {
      Modal.confirm({
        title: () => '¿Está seguro que desea cancelar el ticket de baja?',
        icon: () => createVNode(ExclamationCircleOutlined),
        okText: () => 'Sí',
        cancelText: () => 'No',
        onOk() {
          cancelTickets();
        },
        onCancel() {}
      });
    };

    // * Ejecutar ticket
    const loading = ref(false);
    const ejecutar = async () => {
      loading.value = true;
      try {
        await store.dispatch(PATCH_V2_POLICY_HOLDER_STATUS, {
          ticketId: exclusionId,
          status: 3
        });
        await getData(exclusionId);
      } catch (error) {
        notification(
          'error',
          'Error',
          error?.response?.data?.message || 'No se pudo ejecutar el ticket.'
        );
        console.log(error);
      } finally {
        loading.value = false;
      }
    };

    const sendToBewell = async () => {
      loading.value = true;
      try {
        await store.dispatch(PATCH_V2_POLICY_HOLDER_STATUS, {
          ticketId: exclusionId,
          status: 7
        });
        await getData(exclusionId);
      } catch (error) {
        notification(
          'error',
          'Error',
          error?.response?.data?.message || 'No se pudo enviar a revisión.'
        );
      } finally {
        loading.value = false;
      }
    };

    const sendToInsurance = async () => {
      loading.value = true;
      try {
        await store.dispatch(PATCH_V2_POLICY_HOLDER_STATUS, {
          ticketId: exclusionId,
          status: 8
        });
        await getData(exclusionId);
      } catch (error) {
        notification(
          'error',
          'Error',
          error?.response?.data?.message ||
            'No se pudo enviar a la aseguradora.'
        );
      } finally {
        loading.value = false;
      }
    };

    const openExecuteModal = () => {
      Modal.confirm({
        title: () => '¿Está seguro que desea ejecutar el ticket de baja?',
        icon: () => createVNode(ExclamationCircleOutlined),
        okText: () => 'Sí',
        cancelText: () => 'No',
        onOk() {
          ejecutar();
        },
        onCancel() {}
      });
    };

    const brokerName = ref('');

    // * Obtencion de la data principal
    const getData = async (id) => {
      try {
        // Obtengo data del ticket
        const fetchedTicketData = await getTicketData(id);
        policyHolderExclusions.value =
          (await store.dispatch(FETCH_V2_POLICY_HOLDER_EXCLUSIONS, id)) || [];
        await loadDependentPreview(fetchedTicketData.employee?.id);
        const exclusionDates = [
          ...new Set(
            policyHolderExclusions.value
              .map((exclusion) => exclusion.endDate)
              .filter(Boolean)
          )
        ];
        if (exclusionDates.length === 1) {
          ticket.endDate = parseDate(exclusionDates[0]).substring(0, 10);
        } else if (exclusionDates.length > 1) {
          ticket.endDate = exclusionDates
            .map((date) => parseDate(date).substring(0, 10))
            .join(', ');
        }

        brokerName.value = await getBroker(ticket.brokerId);

        // Obtengo los comentarios asociados al ticket
        await getCommentsFromTicket(id);

        await getAllCasesByTicketId(id);

        // Obtengo el registro de archivos enviados por el ticket
        await getFilesRecordsFromTicket(id);

        // Obtengo los grupos que pertenece el asegurado

        // Obtengo las las polizas junto con su compania aseguradora

        // // Creo la data para pasarsela a la tabla principal descriptiva
        // const dataToTable = {
        //   name:ticket.value.employee.firstName,
        //   last_name:ticket.value.employee.firstSurname,
        //   rut:ticket.value.employee.rut,
        //   company:ticket.value.company.businessName,
        //   insurance:insurance_companies.value,
        //   policies:policies.value,
        //   endDate:(parseDate(ticket.value.endDate)).substring(0,10)
        // };

        // crearDataToTable(dataToTable);

        // Actualizar data para el stepper
        await stepperData(id, fetchedTicketData);
      } catch (error) {
        console.error(error);
        if (error instanceof TypeError) {
          throw error;
        }
      }
    };

    onMounted(() => {
      getData(exclusionId).catch((error) => console.error(error));
      getTicketOptionalFiles();
    });

    // * Crear data para la tabla principal
    const dataToTable = computed(() => {
      return [
        {
          key: 'Nombre',
          value:
            ticket?.employee?.fullname ||
            (ticket?.employee?.firstName && ticket?.employee?.firstSurname
              ? `${ticket.employee.firstName} ${ticket.employee.firstSurname}`
              : '')
        },
        {
          key: 'RUT',
          value: ticket.employee ? rutHelper.formatRut(ticket.employee.rut) : ''
        },
        {
          key: 'Empresa',
          value: ticket.company ? ticket.company.businessName : ''
        },
        {
          key: 'Aseguradora',
          value: ticket.insurance ? ticket.insurance : ''
        },
        {
          key: 'Pólizas',
          value: ticket.policies ? ticket.policies : ''
        },
        {
          key: 'Fecha de término',
          value: ticket.endDate
        },
        {
          key: 'Broker',
          value: brokerName.value || ''
        }
      ];
    });

    return {
      getTicketData,
      ticket,
      policyHolderExclusionRows,
      coverageExclusionColumns,
      dependentPreviewRows,
      dependentPreviewColumns,
      loadingDependentPreview,
      dependentPreviewError,
      dependentPreviewEmptyMessage,
      stepperProps,
      stepperRef,
      loading,
      dataToTable,
      orderedRecords,
      commentsOrdered,
      getNewCommment,
      exclusionId,
      routes,
      headerStateData,
      openCancelModal,
      openExecuteModal,
      sendToBewell,
      sendToInsurance,
      userRole,
      showOnlyCancel,
      ticketStateId,
      recordsSteps,
      recordsComments,
      loadTicket,
      loadingHistory,
      cases,
      redirectCase,
      updateEndDateVisible,
      newEndDate,
      updateEndDate,
      insuranceMessage,
      getTicketOptionalFiles,
      ticketOptionalFiles,
      loadingOptionalFiles,
      goToTicketGroup
    };
  }
};
</script>
